import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { generateSchema, guarantors } from '../shared';

const defaultSchema = {
  enterprise: guarantors,
};

const customSchemas = {
  [FINANCIAL_PRODUCT.SME]: defaultSchema,
};

type CustomSchemaType = typeof customSchemas;

export const guarantorDetailsFormSchema = generateSchema<CustomSchemaType, typeof defaultSchema>({
  customSchemas,
  defaultSchema,
});

export type GuarantorDetailsFormType = z.infer<typeof guarantorDetailsFormSchema>;
